import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'moon-banner',
    templateUrl: './moon.component.html',
    styleUrls: ['./moon.component.css'],
    standalone: false
})
export class MoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
